import { render, staticRenderFns } from "./SocialPostsTableEditoriaux.vue?vue&type=template&id=444592e9&scoped=true&"
import script from "./SocialPostsTableEditoriaux.vue?vue&type=script&lang=js&"
export * from "./SocialPostsTableEditoriaux.vue?vue&type=script&lang=js&"
import style0 from "./SocialPostsTableEditoriaux.vue?vue&type=style&index=0&id=444592e9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "444592e9",
  null
  
)

export default component.exports